<template>
  <div id="page" v-if="isRender">
    <page-header v-if="isShow"></page-header>
    <main id="main">
      <template v-if="showPageMainTop">
        <page-main-top></page-main-top>
      </template>
      <router-view></router-view>
      <!-- /#main -->
    </main>
    <page-footer v-if="isShow" ref="footer"></page-footer>
    <!-- /#page -->
  </div>
</template>
<style>
@import "./assets/styles/common.css";
</style>
<style lang="scss">
@import "./assets/styles/common-extend.scss";
@import "./assets/styles/bootstrap-extend.scss";
</style>
<script>
import Vue from "vue";
import PageHeader from "@/components/PageHeader";
import PageFooter from "@/components/PageFooter";
import PageMainTop from "@/components/PageMainTop";
import networkConst from "@/constants/network-const";
import EventLogService from "@/core/utils/event-log-service";
import CommonService from "@/core/utils/common-service";
import BrowserService from "@/core/utils/browser-service";

const systemName = "Common.system_name";
const maintainServerPath = "/maintainserver";
const errorServerPath = "/errorserver";
export default {
  data() {
    return {
      isRender: false,
      showPageMainTop: true,
      isShow: true,
      lastActiveTime: new Date().getTime(),
      refreshErrorCount: 0,
      checkInterval: null,
      isAutoCheck: false,
      currentPath: "",
      systemInfo: null
    };
  },
  async created() {
    await this.$store.dispatch("getAuthenticatedUser").then(() => {
      const loginUserName = this.$store.getters.authenticatedUser.loginUserName;
      this.systemInfo = this.$store.getters.authenticatedUser.settingSystemFlg;
      if (loginUserName !== undefined) {
        EventLogService.writeLog(
          "1",
          "メインメニュー画面",
          "ワールドポータル利用開始",
          0,
          "KYG002001"
        );
      }
      this.checkSettingSymtemBeforeNextPage();
      this.convertTimeOut();
    });
  },
  mounted() {
    this.lastActiveTime = new Date().getTime();
    this.refreshErrorCount = 0;
    const body = document.getElementsByTagName("BODY")[0];

    const updateActiveTime = () => {
      this.checkIdleTime();
    };

    body.addEventListener("click", updateActiveTime);
    body.addEventListener("keypress", updateActiveTime);
    body.addEventListener("scroll", updateActiveTime);
    body.addEventListener("resize", updateActiveTime);

    this.checkInterval = setInterval(() => {
      this.isAutoCheck = true;
    }, networkConst.USER_INACTIVE_CHECK_INTERVAL);
    const browserInfo = BrowserService.getBrowser(true);
    // Window OSの場合
    if (browserInfo.os.indexOf("Window") !== -1) {
      this.addStyleForWindow();
    }
  },
  beforeDestroy: function() {
    this.clearCheckInterval();
  },
  components: {
    PageHeader,
    PageFooter,
    PageMainTop
  },
  methods: {
    checkIdleTime() {
      if (!this.isAutoCheck) {
        return;
      }
      Vue.axios
        .get("/refreshsession", {
          handlerEnabled: false,
          isNotHandlerNetwork: true
        })
        .then(() => {
          this.isAutoCheck = false;
          this.lastActiveTime = new Date().getTime();
          sessionStorage.setItem("lastActiveTime", this.lastActiveTime);
        })
        .catch(error => {
          if (error.isUnauthorized || error.isForbidden) {
            this.transitionToErrorServer(error);
          }
        });
    },
    transitionToErrorServer(error) {
      this.clearCheckInterval();
      CommonService.gotoErrorPage(error);
    },
    clearCheckInterval() {
      if (this.checkInterval) {
        clearInterval(this.checkInterval);
      }
    },
    convertTimeOut() {
      let sessionTimeOut = this.$store.getters.authenticatedUser.sessionTimeOut;
      if (sessionTimeOut !== undefined) {
        if (sessionTimeOut.indexOf("m") > 0) {
          sessionTimeOut = parseInt(sessionTimeOut.replace("m", "")) * 60;
        }
        sessionStorage.setItem("sessionTimeOut", sessionTimeOut);
        sessionStorage.setItem("lastActiveTime", this.lastActiveTime);
      }
    },
    checkSettingSymtemBeforeNextPage() {
      const currentPath = this.$route.path;
      const settingSystemFlg = this.$store.getters.authenticatedUser
        .settingSystemFlg;

      switch (currentPath) {
        case "/":
        case "/check-transport-service":
        case "/search-prohibitions":
        case maintainServerPath:
        case errorServerPath:
          this.isRender = true;
          break;
        case "/using-settings":
          if (settingSystemFlg) {
            window.location.href = errorServerPath;
          }
          this.isRender = true;
          break;
        default:
          if (settingSystemFlg) {
            this.isRender = true;
            break;
          } else {
            window.location.href = errorServerPath;
          }
      }
    },
    addStyleForWindow() {
      const styleCss =
        ".box-scroll-02 thead::-webkit-scrollbar, .box-scroll-03 thead::-webkit-scrollbar, .box-scroll-06 thead::-webkit-scrollbar {visibility: hidden;}";
      const head = document.head || document.getElementsByTagName("head")[0];
      const style = document.createElement("style");
      head.appendChild(style);
      style.type = "text/css";
      if (style.styleSheet) {
        // This is required for IE8 and below.
        style.styleSheet.cssText = styleCss;
      } else {
        style.appendChild(document.createTextNode(styleCss));
      }
    }
  },
  watch: {
    $route: function(to) {
      const currentPath = this.$route.path;
      const errorResponse = this.$route.params.errorResponse;
      this.showPageMainTop = !(
        maintainServerPath === currentPath || errorServerPath === currentPath
      );

      this.isShow = maintainServerPath !== currentPath;

      this.currentPath = currentPath;

      if (errorResponse !== undefined) {
        if (errorServerPath === currentPath && errorResponse.isForbidden) {
          document.title =
            this.$t(to.meta.titleConnectionErr) + "｜" + this.$t(systemName);
          return;
        }
      }

      if (!to.meta.title) {
        document.title = this.$t(systemName);
        return;
      }

      document.title = this.$t(to.meta.title) + "｜" + this.$t(systemName);
    }
  }
};
</script>
